/**
 * The `session.new` command, registered once for the whole app as soon as a page module
 * imports this file: key n and the palette's "New session" work on every page.
 */
import { Plus } from '@orgus/ui/icons';
import { registerCommands } from '../../lib/commands.ts';
import { openNewSession } from './store.ts';

let registered = false;

export function registerNewSessionCommand(): void {
  if (registered) return;
  registered = true;
  registerCommands([
    {
      id: 'session.new',
      title: 'New session',
      subtitle: 'Start Claude Code in a project, on any machine',
      group: 'Actions',
      icon: Plus,
      shortcut: ['n'],
      keywords: ['start', 'claude', 'run', 'prompt', 'worktree'],
      order: 0,
      perform: () => openNewSession(),
    },
  ]);
}

registerNewSessionCommand();
